import { SetStateAction } from 'react';
import { logEvent } from '../../lib/analytics';

interface SeeFullCalendarProps {
  calendlyUriFullCalendar: string | null | undefined;
  calendlyUri: string;
  setCalendlyModalUri: (value: SetStateAction<string | undefined>) => void;
}

export const SeeFullCalendar: React.FC<SeeFullCalendarProps> = ({
  calendlyUriFullCalendar,
  calendlyUri,
  setCalendlyModalUri,
}) => (
  <button
    className="text-xs font-semibold text-blue-600 hover:text-blue-700 "
    onClick={() => {
      setCalendlyModalUri(calendlyUriFullCalendar ?? calendlyUri);
      logEvent({
        category: 'Agent Directory',
        name: 'See full calendar button clicked',
        calendlyUri: calendlyUriFullCalendar ?? calendlyUri,
      });
    }}
  >
    See full calendar
  </button>
);
